import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import PaymentBadge from "@molecules/ObjectCard/Attributes/AttributeBadges/PaymentBadge/PaymentBadge"

import { InvoicePaymentBadgeProps } from "./InvoicePaymentBadge.types"

// Paid status indicator for invoices. Only rendered once an invoice is in a billable
// lifecycle — Paid, Forgiven, Outstanding, or Overdue.
export default function InvoicePaymentBadge(props: InvoicePaymentBadgeProps) {
    const { status, total, amountPaid, amountUncollectible, amountDue, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    if (status === "Paid") {
        const tooltip = Number(total) === 0 ? "Paid\nZero-total invoice" : `Paid\n${formatCurrency(amountPaid)}`
        return (
            <PaymentBadge level="full" size={size} tooltip={tooltip}>
                Paid
            </PaymentBadge>
        )
    }

    if (status === "Forgiven") {
        // amountPaid includes the forgiven balance (recorded as an uncollectible payment), so the
        // amount actually collected is what remains once the write-off is taken back out.
        const amountCollected = Number(amountPaid) - Number(amountUncollectible)
        const tooltip =
            amountCollected > 0
                ? `Forgiven\n${formatCurrency(amountCollected)} paid\n${formatCurrency(amountUncollectible)} written off`
                : `Forgiven\n${formatCurrency(amountUncollectible)} written off`
        return (
            <PaymentBadge level="full" size={size} tooltip={tooltip}>
                Paid
            </PaymentBadge>
        )
    }

    if (status === "Outstanding" || status === "Overdue") {
        const isPartiallyPaid = Number(amountPaid) > 0
        const tooltipLabel = isPartiallyPaid ? "Remaining" : "Required"
        return (
            <PaymentBadge
                level={isPartiallyPaid ? "partial" : "none"}
                isEscalated={status === "Overdue"}
                size={size}
                tooltip={`${tooltipLabel}\n${formatCurrency(amountDue)}`}
            >
                Unpaid
            </PaymentBadge>
        )
    }

    return null
}
